var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V9.8C20 9.51997 20 9.37996 19.9455 9.273C19.8976 9.17892 19.8211 9.10243 19.727 9.0545C19.62 9 19.48 9 19.2 9H17C14.7909 9 13 7.20914 13 5V2.8C13 2.51997 13 2.37996 12.9455 2.273C12.8976 2.17892 12.8211 2.10243 12.727 2.0545C12.62 2 12.48 2 12.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803Z",
    fill: "#D5DAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.70711C15 2.31658 15.3166 2 15.7071 2C15.8946 2 16.0745 2.0745 16.2071 2.20711L19.7929 5.79289C19.9255 5.9255 20 6.10536 20 6.29289C20 6.68342 19.6834 7 19.2929 7H17C15.8954 7 15 6.10457 15 5V2.70711Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7a93af32287bdee600fd627743211ad8.svg";
export { ForwardRef as ReactComponent };